// extracted by mini-css-extract-plugin
export default {"placeholderBlock":"VKkY8nczWVrBgBVcP_t8"};